exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a{color:#515151}.delete_btnhover:hover{color:#ee5150!important}.downloads_btnhover:hover,.preview_btnhover:hover{color:#073482!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a631f20","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lease-termination-agreement.vue
// module id = 72
// module chunks = 0